import { useMemo } from "react";

import { MainNavigationMenuItem } from "components/MainNavigation/types";
import useAssistantPanelAvailableViews from "components/AssistantPanel/hooks/useAvailableViews";
import { Book, LogoInfraAssistantColored } from "components/icons/generated";
import { AssistantPanelView } from "components/AssistantPanel/Layout/types";

import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const AI_CHAT_MENU_ITEM =
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.AiChat];

const useAiChatItem = (): MainNavigationMenuItem => {
  const availableViews = useAssistantPanelAvailableViews();
  const hasChatView = availableViews.includes(AssistantPanelView.CHAT);

  return useMemo(
    () => ({
      id: AI_CHAT_MENU_ITEM.id,
      title: hasChatView ? AI_CHAT_MENU_ITEM.title : "Learn",
      icon: hasChatView ? LogoInfraAssistantColored : Book,
      to: AI_CHAT_MENU_ITEM.to,
      routeRule: AI_CHAT_MENU_ITEM.routeRule,
    }),
    [hasChatView]
  );
};

export default useAiChatItem;
